import React from 'react';
import {
  Text, View,
} from 'react-native';
import { textSecondary_9_3 } from './TextStyle';

const ParagraphSecondaryBackground = ({
  globJSON, txt, simPlatform,
}) => (
  <View style={{
    alignSelf: 'center',
    width: 200,
    borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
    backgroundColor: globJSON.configurations.theme.colors.light_elements_color,
    paddingHorizontal: 9,
    marginBottom: 10,
  }}
  >
    <Text style={[textSecondary_9_3(globJSON, simPlatform), { paddingVertical: 6 }]}>
      {txt}
    </Text>
  </View>
);
export default ParagraphSecondaryBackground;
